interface ITargetAudience {
  shortSpecCount?: number
  title?: string
  specialties: Array<string>
}

const geriatricSpecialties = [
  'Акушерство и гинекология',
  'Аллергология и иммунология',
  'Гастроэнтерология',
  'Гематология',
  'Гериатрия',
  'Дерматовенерология',
  'Диетология',
  'Инфекционные болезни',
  'Кардиология',
  'Клиническая лабораторная диагностика',
  'Клиническая фармакология',
  'Колопроктология',
  'Лечебная физкультура и спортивная медицина',
  'Лечебное дело',
  'Неврология',
  'Нейрохирургия',
  'Нефрология',
  'Общая врачебная практика (семейная медицина)',
  'Онкология',
  'Оториноларингология',
  'Офтальмология',
  'Психиатрия',
  'Пульмонология',
  'Ревматология',
  'Рефлексотерапия',
  'Сердечно-сосудистая хирургия',
  'Терапия',
  'Травматология и ортопедия',
  'Трансфузиология',
  'Ультразвуковая диагностика',
  'Урология',
  'Физиотерапия',
  'Физическая и реабилитационная медицина',
  'Фтизиатрия',
  'Функциональная диагностика',
  'Хирургия',
  'Эндоскопия',
  'Эндокринология',
]

const miniCardioSpecialties = [
  'Кардиология',
  'Акушерство и гинекология',
  'Гастроэнтерология',
  'Гематология',
  'Гериатрия',
  'Клиническая лабораторная диагностика',
  'Клиническая фармакология',
  'Лечебное дело',
  'Лечебная физкультура и спортивная медицина',
  'Неврология',
  'Нефрология',
  'Общая врачебная практика (семейная медицина)',
  'Ревматология',
  'Терапия',
  'Травматология и ортопедия',
  'Хирургия',
  'Эндокринология',
]

const osteoSpecialties = [
  'Эндокринология',
  'Акушерство и гинекология',
  'Гематология',
  'Клиническая лабораторная диагностика',
  'Лечебное дело',
  'Нефрология',
  'Ревматология',
  'Травматология и ортопедия',
  'Гериатрия',
  'Гастроэнтерология',
  'Кардиология',
  'Лечебная физкультура и спортивная медицина',
  'Неврология',
  'Общая врачебная практика (семейная медицина)',
  'Терапия',
  'Хирургия',
]

const modernMethodsDmpSpecialties = [
  'Общая врачебная практика (семейная медицина)',
  'Кардиология',
  'Организация здравоохранения и общественное здоровье',
  'Оториноларингология',
  'Терапия',
  'Эндокринология',
  'Педиатрия',
]

export {
  geriatricSpecialties,
  miniCardioSpecialties,
  osteoSpecialties,
  modernMethodsDmpSpecialties,
}
export type { ITargetAudience }
